import { render, staticRenderFns } from "./AllPurchaseAndSaleMatching.vue?vue&type=template&id=88a76192&scoped=true"
import script from "./AllPurchaseAndSaleMatching.vue?vue&type=script&lang=js"
export * from "./AllPurchaseAndSaleMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a76192",
  null
  
)

export default component.exports